import { useSearchTokensQuery } from "@/hooks";
import { TabListBaseProps } from "@/routes/trade/-search/categories/shared";
import { TokenList } from "../token-list";

type SearchTokenQueryResult = ReturnType<typeof useSearchTokensQuery>;

interface AllListProps extends TabListBaseProps {
  searchTokenQueryResult: SearchTokenQueryResult;
  extraHeight?: number;
}

export function AllList({
  searchTokenQueryResult,
  onSelectToken,
  scrollRef,
  extraHeight,
}: AllListProps) {
  const { rows, debouncedParams, isFetching, hasNextPage, goNextPage } =
    searchTokenQueryResult;

  return (
    <TokenList
      ref={scrollRef}
      rows={rows}
      id="all-token-list"
      searchKey={debouncedParams.filter ?? "none"}
      isFetching={isFetching}
      hasNextPage={hasNextPage}
      onSelectToken={onSelectToken}
      onNextPage={goNextPage}
      extraHeight={extraHeight}
    />
  );
}
